import { useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useDispatch, useSelector } from 'react-redux';

import {
  Center,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Spinner,
} from '@frontend/legacy-components';

import { GenericError } from 'modules/common/components';

import { FacilityForm } from './FacilityForm';
import { facilityDrawer } from './data/actions';
import { MODES } from './data/constants';
import { getIsLoading, getIsOpen, getMode } from './data/reducer';

const FacilityDrawer = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector(getIsLoading);
  const isOpen = useSelector(getIsOpen);
  const mode = useSelector(getMode);

  const close = useCallback(() => dispatch(facilityDrawer.close()), [dispatch]);

  return (
    <Drawer onClose={close} isOpen={isOpen} size="sm">
      <DrawerContent>
        <DrawerHeader>
          {mode === MODES.CREATE ? 'Create New Facility' : 'Edit Facility'}
          <DrawerCloseButton />
        </DrawerHeader>
        <ErrorBoundary FallbackComponent={() => <GenericError pt={3} />}>
          {isLoading ? (
            <Center flex={1}>
              <Spinner size="lg" />
            </Center>
          ) : (
            <FacilityForm />
          )}
        </ErrorBoundary>
      </DrawerContent>
    </Drawer>
  );
};

export default FacilityDrawer;
